import { merge } from 'rxjs';
import { DynamicFormControl } from './dynamic-form-control';
/**
 * depending on validation types, a control's validity may be affected by just the value itself or by a parent form value.
 */
export function getValidationTriggerEvents(control) {
  let validationScope = 'self';
  if (control instanceof DynamicFormControl) {
    const flags = control.fieldDefinition.validationFlags;
    if (flags.parentConditional) validationScope = 'root';else if (flags.conditional) validationScope = 'parent';else if (flags.nested) validationScope = 'parent';
  }
  let eventSrc;
  if (validationScope === 'self') {
    eventSrc = control.events;
  } else if (validationScope === 'parent') {
    eventSrc = merge(control.events.pipe(), control.parent.events);
  } else if (validationScope === 'root') {
    eventSrc = merge(control.events.pipe(), control.root.events);
  }
  return eventSrc;
}
export function getControlName(control) {
  return Object.entries(control.parent?.controls || {}).find(([name, val]) => val === control)?.[0] || 'root';
}